











import { View } from 'client-website-ts-library/plugins';
import { Component } from 'vue-property-decorator';
import { Profile, Context } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';
import { ContextItemType } from 'client-website-ts-library/types/Context';

import Form from '../components/Forms/Form.vue';

@Component({
  components: {
    Form,
  },
})
export default class RentalAppraisal extends View {
  private profile: Profile | null = null;

  private formData: Context | null = null;

  initializeContext() {
    this.formData = {
      Items: [],
      ClientWebsiteId: Config.Website.Id,
      WebsiteId: Config.Website.Settings!.WebsiteId,
      WebsiteLevel: Config.Website.Settings!.WebsiteLevel,
    };
  }

  resolveId() {
    const { id } = this.$route.params;

    if (!id) {
      this.initializeContext();
      return;
    }

    if (id.length === 36) {
      // If the ID is 36 long we'll treat it as a guid
      this.updateAgent(id);
    } else {
      API.Slugs.Resolve(id).then((resolved) => {
        if (resolved.Type === 'Profile') {
          this.updateAgent(resolved.Id);
        }
      });
    }
  }

  updateAgent(id: string) {
    this.formData = null;

    API.Profiles.Get(id).then((profile) => {
      this.profile = profile;

      this.$emit('updateView');

      this.formData = {
        Items: [{
          Type: ContextItemType.EnquiryTargetProfile,
          Id: profile.Id,
        }],
        ClientWebsiteId: Config.Website.Id,
        WebsiteId: Config.Website.Settings!.WebsiteId,
        WebsiteLevel: Config.Website.Settings!.WebsiteLevel,
      };
    });
  }

  mounted() {
    this.resolveId();
  }
}
